export default function isNotificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}
